import 'vue-toastification/dist/index.css'

export interface ITools {
  clean: Function
  delay: Function
  debounce: Function
  appendNatureOfIns: Function
}

export default defineNuxtPlugin((nuxtApp) => {
  let timer: any
  const delay = (t: number) => {
    return new Promise((resolve) => {
      setTimeout(resolve, t)
    })
  }
  const clean = (obj: any, ...props: any) => {
    const newObj = { ...obj }
    delete newObj?.createdAt
    delete newObj?.updatedAt
    delete newObj?.revision
    delete newObj?.id
    props.forEach((p: any) => {
      delete newObj[p]
    })
    return newObj
  }
  const debounce = (fn: Function, wait: any) => {
    return function (...args: any) {
      if (timer) {
        clearTimeout(timer)
        timer = null
      }

      timer = setTimeout(() => {
        fn.apply(args)
      }, wait)
    }
  }
  const appendNatureOfIns = (item: any) => {
    let nhi = item.nhi
    if (item.nhi) {
      if (['1.2.250.1.213.1.4.8', '1.2.250.1.213.1.4.10', '1.2.250.1.213.1.4.11'].includes(item.nhiCreatorOid))
        nhi += ` (NIR)`
      if (['1.2.250.1.213.1.4.9'].includes(item.nhiCreatorOid)) nhi += ` (NIA)`
    }
    return nhi
  }
  const tools: ITools = {
    clean,
    delay,
    debounce,
    appendNatureOfIns,
  }
  return {
    provide: {
      toolkit: tools,
    },
  }
})
